import React from 'react';
import CampaignSidebar from '../features/CampaignSidebar';

const Layout = ({ children }) => {
  return (
    <div className="App-container">
      <CampaignSidebar />
      <div className="dashboard-container">
        {children}
      </div>
    </div>
  );
};

export default Layout;
